import { Injectable, Signal } from '@angular/core';
import { ICountryData, ICountryModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { CountryActions, CountrySelectors, ICountryState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class CountryStore extends StateAccessService<ICountryState> {
  readonly state$: Observable<ICountryState>;

  readonly data$$: Signal<ICountryData>;
  readonly model$$: Signal<ICountryModel>;

  constructor() {
    super();

    this.state$ = this.stateFacade.select$(CountrySelectors.countryState);

    this.model$$ = this.stateFacade.selectSignal$(CountrySelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(CountrySelectors.data);
  }

  dispatchCountryReset() {
    this.stateFacade.dispatch(CountryActions.reset());
  }
  dispatchCountryLoad() {
    this.stateFacade.dispatch(CountryActions.load());
  }
  dispatchCountryLoadSuccess({ model, data }: { model: ICountryModel; data: ICountryData }) {
    this.stateFacade.dispatch(CountryActions.loadSuccess({ model, data }));
  }
}
